import { Button, Icon } from "@livingmap/hippo";

import styles from "./Modal.module.scss";

interface Props {
  onCancel: () => void;
  onConfirm: () => void;
}

const UnsavedChanges: React.FC<Props> = ({ onCancel, onConfirm }) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h5 className={styles.title}>Exit without saving?</h5>
        <button className={styles.closeButton} onClick={onCancel}>
          <Icon dataQA="close-icon" name="close" size={18} />
        </button>
      </div>
      <div className={styles.contentContainer}>
        <p className={styles.description}>
          Changes you made will not be saved.
        </p>
        <div className={styles.buttonWrapper}>
          <Button
            dataQA="keep-editing-button"
            type="primary"
            size="regular"
            style="filled"
            text="Keep editing"
            onClick={onCancel}
          />
          <Button
            dataQA="exit-button"
            type="primary"
            size="regular"
            style="filled"
            text="Exit"
            onClick={onConfirm}
          />
        </div>
      </div>
    </div>
  );
};

export default UnsavedChanges;
